import { Injectable } from '@angular/core';

@Injectable()
export class TitleService {
  title = 'Home';

  getTitle(): string {
    return this.title;
  }

  setTitle(title: string) {
    this.title = title;
  }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/services/utility-services/title.service.ts
 **/